import { useMutation } from '@tanstack/react-query';
import axiosInstance from '../utils/axios.utils';
import endPointAPI from '../utils/endPointAPI';
import { toastify } from '../components/Common/ToastMessage/Toastify';

interface UpdateTokenParams {
  apiToken: string;
}

export const useUpdateToken = () => {
  return useMutation({
    mutationFn: async ({ apiToken }: UpdateTokenParams) => {
      const { data } = await axiosInstance.post(endPointAPI.SETTINGS.UPDATE_CLOCKIFY_TOKEN, {
        apiToken,
      });
      return data;
    },
    onSuccess: () => {
      toastify.success('Clockify token updated successfully');
    },
  });
};
